import { QuestionTheme } from "../../../../features/questionnaire/QuestionnaireUtils";
import { colors } from "../../../utils/helpers";
import ActionCardCornerContainer from "./ActionCardCornerContainer";
import { ActionCategory } from "@pslifestyle/common/src/types/planTypes";
import { useTranslation } from "react-i18next";

interface Props {
  category: ActionCategory;
  calculatedImpact: number;
  percentReduction: number;
  showGranularActionPotential?: boolean;
}

const ImpactActionCardCorner = ({
  category,
  calculatedImpact,
  percentReduction,
  showGranularActionPotential,
}: Props) => {
  const impactPercentageOnTotalFootprint = percentReduction.toFixed(1);
  const { t } = useTranslation("recommendations");
  return (
    <ActionCardCornerContainer
      variant={category.toLowerCase() as QuestionTheme}
      showGranularActionPotential={showGranularActionPotential}
    >
      {showGranularActionPotential && (
        <span
          className={`body-sm-b text-center text-${colors[category.toLowerCase()]}-dark`}
        >
          {t("potentialImpactLabel")}
        </span>
      )}
      <span
        className={`headline-xs-sb text-${colors[category.toLowerCase()]}-dark`}
      >
        -{impactPercentageOnTotalFootprint}%
      </span>
      <span className="body-sm text-center leading-4 mt-px">
        {calculatedImpact.toFixed()} kgCO<sub>2</sub>e
      </span>
    </ActionCardCornerContainer>
  );
};

export default ImpactActionCardCorner;
